var _path, _path2, _path3, _ellipse, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertficatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 480 480",
    fill: "none",
    stroke: "black",
    strokeWidth: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.199 367C204.956 367 124.442 367 22.0108 367C15.3833 367 10 361.627 10 355V51C10 44.3726 15.3726 39 22 39H458C464.627 39 470 44.3726 470 51V355C470 361.627 464.627 367 458 367C447.393 367 436.216 367 427.047 367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M398.151 122H73.4057C72.3012 122 71.4332 122.895 71.4332 124C71.4332 125.105 72.3287 126 73.4332 126H398.076C399.181 126 400.076 125.105 400.076 124C400.076 122.895 399.256 122 398.151 122Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.533 204H73.6832C72.4406 204 71.4332 205.007 71.4332 206.25C71.4332 207.493 72.4406 208.5 73.6832 208.5H207.533C208.775 208.5 209.783 207.493 209.783 206.25C209.783 205.007 208.775 204 207.533 204Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.622,
    cy: 262,
    rx: 77.4159,
    ry: 77.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.684 311L285.846 432.618C285.36 436.604 289.533 439.508 293.101 437.667L356.813 404.804C358.26 404.058 359.979 404.063 361.422 404.817L423.833 437.448C427.456 439.341 431.697 436.324 431.096 432.281L413.062 311"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertficatIcon);
export default __webpack_public_path__ + "static/media/certficat-icon.eb2e4488f11512a0a0f7b5a6c58401a4.svg";
export { ForwardRef as ReactComponent };